module.exports = __webpack_public_path__ + "media/lineas/2-ddf93cd8.png";